import sdkInstanceProvider from "../../providers/sdkInstanceProvider";
import { SdkError } from "../errors";

export default async () => {
  const {
    customer: { customerId: getCustomerId, isAuthenticated: getIsAuthenticated }
  } = await sdkInstanceProvider("identity");

  try {
    const [isAuthenticated, customerId] = await Promise.all([
      getIsAuthenticated(),
      getCustomerId()
    ]);

    return { isAuthenticated, customerId };
  } catch (e) {
    throw new SdkError(e);
  }
};
